export default function CalendarCheckIcon({ width = 24, height = 24, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='6.25 5.25 13.97 13.97'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M9.35521 9.67136C9.24044 9.67136 9.1474 9.57832 9.1474 9.46355C9.1474 9.34878 9.24044 9.25574 9.35521 9.25574'
        stroke='currentColor'
      />
      <path
        d='M9.35547 9.67136C9.47024 9.67136 9.56328 9.57832 9.56328 9.46355C9.56328 9.34878 9.47024 9.25574 9.35547 9.25574'
        stroke='currentColor'
      />
      <path
        d='M11.5719 9.67136C11.4571 9.67136 11.3641 9.57832 11.3641 9.46355C11.3641 9.34878 11.4571 9.25574 11.5719 9.25574'
        stroke='currentColor'
      />
      <path
        d='M11.5719 9.67136C11.6867 9.67136 11.7797 9.57832 11.7797 9.46355C11.7797 9.34878 11.6867 9.25574 11.5719 9.25574'
        stroke='currentColor'
      />
      <path
        d='M9.35521 11.6109C9.24044 11.6109 9.1474 11.5179 9.1474 11.4031C9.1474 11.2884 9.24044 11.1953 9.35521 11.1953'
        stroke='currentColor'
      />
      <path
        d='M9.35547 11.6109C9.47024 11.6109 9.56328 11.5179 9.56328 11.4031C9.56328 11.2884 9.47024 11.1953 9.35547 11.1953'
        stroke='currentColor'
      />
      <path
        d='M9.35521 13.5505C9.24044 13.5505 9.1474 13.4575 9.1474 13.3427C9.1474 13.2279 9.24044 13.1349 9.35521 13.1349'
        stroke='currentColor'
      />
      <path
        d='M9.35547 13.5505C9.47024 13.5505 9.56328 13.4575 9.56328 13.3427C9.56328 13.2279 9.47024 13.1349 9.35547 13.1349'
        stroke='currentColor'
      />
      <path
        d='M11.5719 11.6109C11.4571 11.6109 11.3641 11.5179 11.3641 11.4031C11.3641 11.2884 11.4571 11.1953 11.5719 11.1953'
        stroke='currentColor'
      />
      <path
        d='M11.5719 11.6109C11.6867 11.6109 11.7797 11.5179 11.7797 11.4031C11.7797 11.2884 11.6867 11.1953 11.5719 11.1953'
        stroke='currentColor'
      />
      <path
        d='M13.7886 9.67136C13.6738 9.67136 13.5807 9.57832 13.5807 9.46355C13.5807 9.34878 13.6738 9.25574 13.7886 9.25574'
        stroke='currentColor'
      />
      <path
        d='M13.7885 9.67136C13.9033 9.67136 13.9963 9.57832 13.9963 9.46355C13.9963 9.34878 13.9033 9.25574 13.7885 9.25574'
        stroke='currentColor'
      />
      <path
        d='M11.1562 15.1438H7.83125C7.61079 15.1438 7.39935 15.0562 7.24347 14.9004C7.08758 14.7445 7 14.533 7 14.3125V7.66255C7 7.44209 7.08758 7.23065 7.24347 7.07477C7.39935 6.91888 7.61079 6.8313 7.83125 6.8313H15.3125C15.5329 6.8313 15.7444 6.91888 15.9003 7.07477C16.0562 7.23065 16.1437 7.44209 16.1437 7.66255V10.1563'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M9.49377 7.6625V6' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M13.65 7.6625V6' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M15.8 18.0001C17.5673 18.0001 19 16.5674 19 14.8001C19 13.0328 17.5673 11.6001 15.8 11.6001C14.0327 11.6001 12.6 13.0328 12.6 14.8001C12.6 16.5674 14.0327 18.0001 15.8 18.0001Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.2261 13.8694L15.6767 15.9355C15.6423 15.9813 15.5984 16.0193 15.548 16.0466C15.4977 16.074 15.4421 16.0903 15.3849 16.0943C15.3277 16.0984 15.2703 16.0901 15.2166 16.0701C15.1629 16.05 15.1141 16.0187 15.0735 15.9782L14.2735 15.1782'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
